import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-row" }
const _hoisted_2 = { class: "w-10 text-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "pt-1 pr-2" }, " 年 ", -1)
const _hoisted_4 = { class: "w-6 text-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "pt-1 pr-2" }, " 月 ", -1)
const _hoisted_6 = { class: "w-6 text-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "pt-1" }, " 日 ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSelectOption = _resolveComponent("BaseSelectOption")!
  const _component_UnderlineSelect = _resolveComponent("UnderlineSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UnderlineSelect, {
      modelValue: _ctx.year,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.year) = $event))
    }, {
      selected: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.year ? `${_ctx.year}` : " "), 1)
      ]),
      options: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.required ? [..._ctx.range(1900, _ctx.thisYear + 1).reverse()] : [undefined, ..._ctx.range(1900, _ctx.thisYear + 1).reverse()], (num, index) => {
          return (_openBlock(), _createBlock(_component_BaseSelectOption, {
            key: index,
            value: num,
            class: "text-center"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(num ? `${num}` : " "), 1)
            ]),
            _: 2
          }, 1032, ["value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _hoisted_3,
    _createVNode(_component_UnderlineSelect, {
      modelValue: _ctx.month,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.month) = $event))
    }, {
      selected: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.month ? `${_ctx.month}` : " "), 1)
      ]),
      options: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.required ? [..._ctx.range(1, 13)] : [undefined, ..._ctx.range(1, 13)], (num, index) => {
          return (_openBlock(), _createBlock(_component_BaseSelectOption, {
            key: index,
            value: num,
            class: "text-center"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(num ? `${num}` : " "), 1)
            ]),
            _: 2
          }, 1032, ["value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _hoisted_5,
    _createVNode(_component_UnderlineSelect, {
      modelValue: _ctx.day,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.day) = $event))
    }, {
      selected: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.day ? `${_ctx.day}` : " "), 1)
      ]),
      options: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.required ? [..._ctx.range(1, 32)] : [undefined, ..._ctx.range(1, 32)], (num, index) => {
          return (_openBlock(), _createBlock(_component_BaseSelectOption, {
            key: index,
            value: num,
            class: "text-center"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(num ? `${num}` : " "), 1)
            ]),
            _: 2
          }, 1032, ["value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _hoisted_7
  ]))
}